"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyState = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var clsx_1 = __importDefault(require("clsx"));
var prop_types_1 = __importDefault(require("prop-types"));
var useStyles = styles_1.makeStyles(function (theme) { return ({
    root: {
        height: '100%',
        color: theme.palette.text.primary,
        minHeight: '100%',
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        textAlign: 'center',
        alignItems: 'center',
    },
    icon: {
        color: theme.palette.text.secondary,
        marginBottom: '1rem',
        display: 'flex',
        fontSize: 96,
    },
    description: {
        color: theme.palette.type === 'dark' ? theme.palette.text.secondary : theme.palette.text.primary,
    },
    actions: {
        marginTop: '1rem',
    },
}); });
var EmptyStateRender = function (props, ref) {
    var actions = props.actions, classes = props.classes, description = props.description, icon = props.icon, title = props.title, otherDivProps = __rest(props, ["actions", "classes", "description", "icon", "title"]);
    var defaultClasses = useStyles(styles_1.useTheme());
    return (react_1.default.createElement("div", __assign({ ref: ref, className: clsx_1.default(defaultClasses.root, classes.root), "data-test": 'frame' }, otherDivProps),
        icon && react_1.default.createElement("div", { className: clsx_1.default(defaultClasses.icon, classes.icon) }, icon),
        react_1.default.createElement(Typography_1.default, { variant: "h6", color: "inherit", className: classes.title }, title),
        description && (react_1.default.createElement(Typography_1.default, { variant: "subtitle2", color: 'textSecondary', className: clsx_1.default(defaultClasses.description, classes.description) }, description)),
        actions && react_1.default.createElement("div", { className: clsx_1.default(defaultClasses.actions, classes.actions) }, actions)));
};
/**
 * [EmptyState](https://pxblue-components.github.io/react/?path=/info/components-empty-state--get-read-me-story) component
 *
 * The `<EmptyState>` component is an element that can be used as a placeholder when no data is present (such as an empty list, or a placeholder page for future content). This is only used when no data is available, rather than during loading (see [empty states pattern](https://pxblue.github.io/patterns/empty-states)).
 */
exports.EmptyState = react_1.default.forwardRef(EmptyStateRender);
exports.EmptyState.displayName = 'EmptyState';
exports.EmptyState.propTypes = {
    actions: prop_types_1.default.node,
    classes: prop_types_1.default.shape({
        root: prop_types_1.default.string,
        icon: prop_types_1.default.string,
        title: prop_types_1.default.string,
        description: prop_types_1.default.string,
        actions: prop_types_1.default.string,
    }),
    description: prop_types_1.default.node,
    icon: prop_types_1.default.node.isRequired,
    //  @ts-ignore should be node but typescript throws an error here
    title: prop_types_1.default.node.isRequired,
};
exports.EmptyState.defaultProps = {
    classes: {},
};
